import { render } from "./CanceledUnfulfilledPurchasesPage.vue?vue&type=template&id=351e774a"
import script from "./CanceledUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"
export * from "./CanceledUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__